export const PATHS = {
  HOME: '/',
  LOGIN: '/login',
  /** Đặt lại mật khẩu (token trong query `token`). */
  RESET_PASSWORD: '/reset-password',
  DASHBOARD: '/dashboard',
  /** Menu BE `iot_map_view`. */
  MAP_IOT: '/map/iot',
  /** Menu BE `iot_station_management`. */
  IOT_STATIONS: '/iot/stations',
  /** Loại cảm biến (catalog) — mirror `/ops/sensor-types`. */
  IOT_SENSOR_TYPES: '/iot/sensor-types',
  MAP_2D: '/map/2d',
  MAP_3D: '/map/3d',
  SETTINGS: '/settings',
  /** Operations & system management (sidebar shell) */
  OPS: '/ops',
  OPS_AUDIT: '/ops/audit',
  /** Alias thường gặp từ BE — redirect về `/ops/audit`. */
  OPS_AUDIT_LOG_ALIAS: '/ops/audit-log',
  OPS_JOBS: '/ops/jobs',
  /**
   * Tải lên dữ liệu (NetCDF + job API) — menu BE `data_upload`.
   * Bookmark cũ `/ops/netcdf` redirect về đây.
   */
  DATA_UPLOAD: '/data/upload',
  /** @deprecated Dùng {@link DATA_UPLOAD}. Giữ cho URL cũ / tài liệu. */
  OPS_NETCDF_LEGACY: '/ops/netcdf',
  /** Alias path menu BE / tài liệu — redirect về {@link DATA_UPLOAD}. */
  OPS_NETCDF_DATA_ALIAS: '/ops/data/netcdf',
  OPS_USERS: '/ops/users',
  OPS_BASINS: '/ops/basins',
  OPS_STATIONS: '/ops/stations',
  OPS_SENSOR_TYPES: '/ops/sensor-types',
  OPS_ROLES: '/ops/roles',
  /** Phân quyền chức năng theo vai trò (admin) — GET/PUT `/api/roles/features`. */
  OPS_FEATURE_MATRIX: '/ops/permission-matrix',
  OPS_MENUS: '/ops/menus',
  OPS_CATALOG: '/ops/catalog',
  OPS_REPORTS: '/ops/reports',
  /** Báo cáo con — xem `src/features/reports/pages/*`. */
  OPS_REPORTS_OVERVIEW: '/ops/reports/overview',
  OPS_REPORTS_STATIONS: '/ops/reports/stations',
  OPS_REPORTS_WATER_LEVEL: '/ops/reports/water-level',
  OPS_REPORTS_RAINFALL: '/ops/reports/rainfall',
  OPS_REPORTS_ALERTS: '/ops/reports/alerts',
  OPS_REPORTS_FLOOD_EVENTS: '/ops/reports/flood-events',
  OPS_REPORTS_DAMAGE: '/ops/reports/damage',
  OPS_REPORTS_HISTORICAL: '/ops/reports/historical-comparison',
  OPS_SYSTEM_CONFIG: '/ops/system-config',
  OPS_ALERT_SETTINGS: '/ops/alert-settings',
} as const;

export type AppPath = (typeof PATHS)[keyof typeof PATHS];
